import { Box, styled } from '@mui/material';

export const ConfirmationModalWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  zIndex: 99999,
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
}));
